module.exports = __webpack_public_path__ + "static/media/save.e27ab5a5.svg";